import React from "react";
import { useDispatch, useViewState } from "./hooks/useState";

const SearchForm = () => {
  const [keyword, setKeyword] = React.useState("");
  const { updateSearch } = useDispatch();

  const { translations } = useViewState();

  React.useEffect(() => {
    const timeout = setTimeout(() => updateSearch(keyword), 500);
    return () => clearTimeout(timeout);
  }, [keyword]);

  return React.useMemo(
    () => (
      <form
        className="o-findOffice__filterCity"
        onSubmit={(e) => {
          e.stopImmediatePropagation();
          e.preventDefault();
        }}
      >
        <label htmlFor="filter-city" className='is-visually-hidden'>{translations.searchCity}</label>
        <input
          onChange={({ target }) => setKeyword(target.value)}
          className="-large"
          name="filter-city"
          type="text"
          placeholder={translations.searchCity}
          value={keyword}
        />
      </form>
    ),
    [translations, keyword]
  );
};

export default SearchForm;
